import { FC } from 'react'
import CustomButton from '../../UI/CustomButton/CustomButton'
import { EventItem } from '../components/EventItem'
import styles from '../EditClaimCardMainInformation.module.css'

interface EventsSectionProps {
  values: any
  setFieldValue: (field: string, value: any) => void
}

export const EventsSection: FC<EventsSectionProps> = ({ values, setFieldValue }) => {
  const handleAddEvent = () => {
    setFieldValue('events', [...(values.events || []), { name: '', comment: '' }])
  }

  const handleEventNameChange = (index: number, name: string) => {
    const updated = [...(values.events || [])]
    updated[index] = { ...updated[index], name }
    setFieldValue('events', updated)
  }

  const handleCommentChange = (index: number, comment: string) => {
    const updated = [...(values.events || [])]
    updated[index] = { ...updated[index], comment }
    setFieldValue('events', updated)
  }

  const handleTimeStartChange = (index: number, time: string) => {
    const updated = [...(values.events || [])]
    updated[index] = { ...updated[index], timeStart: time }
    setFieldValue('events', updated)
  }

  const handleTimeEndChange = (index: number, time: string) => {
    const updated = [...(values.events || [])]
    updated[index] = { ...updated[index], timeEnd: time }
    setFieldValue('events', updated)
  }

  const handleDelete = (index: number) => {
    const updated = [...(values.events || [])]
    updated.splice(index, 1)
    setFieldValue('events', updated)
  }

  return (
    <div className={styles.sectionBlock}>
      <div className={styles.sectionTitle}>Мероприятия</div>
      <div className={styles.sectionContentSecond}>
        <div className={styles.buttonAddBlock}>
          <div className={styles.rightDateBlock}>
            <div className={styles.segmentInputBlock}>
              <CustomButton
                style={{ width: '100%' }}
                title='Добавить'
                type='button'
                onClick={handleAddEvent}
              />
            </div>
          </div>
        </div>

        {(values.events || []).map((event: any, index: number) => (
          <EventItem
            key={`event-${index}`}
            event={event}
            index={index}
            onEventNameChange={handleEventNameChange}
            onCommentChange={handleCommentChange}
            onTimeStartChange={handleTimeStartChange}
            onTimeEndChange={handleTimeEndChange}
            onDelete={handleDelete}
          />
        ))}
      </div>
    </div>
  )
}
